<!-- src/components/new-tip/StatusBadge.vue -->
<template>
  <v-chip
    :color="status.color"
    :small="!large"
    :large="large"
    label
    outlined
    class="text-capitalize"
  >
    <v-icon v-if="status.icon" left small>{{ status.icon }}</v-icon>
    {{ status.label }}
  </v-chip>
</template>

<script>
import {
  CAMPAIGN_STATUSES,
  ASSIGNMENT_STATUSES,
  VISIT_STATUSES,
  findStatus,
} from '@/constants/newTip';

const MAPS = {
  campaign: CAMPAIGN_STATUSES,
  assignment: ASSIGNMENT_STATUSES,
  visit: VISIT_STATUSES,
};

export default {
  name: 'NewTipStatusBadge',
  props: {
    type: {
      type: String,
      required: true,
      validator: v => ['campaign', 'assignment', 'visit'].includes(v),
    },
    value: { type: String, required: true },
    large: { type: Boolean, default: false },
  },
  computed: {
    status() {
      return findStatus(MAPS[this.type], this.value);
    },
  },
};
</script>
